import Cookies from "js-cookie";
import { getSessionCookieRemoveOptions, removeUserDataCookie } from "utils/common/userCookie";

export async function FetchData(url, options = {}, file = false, blob = false) {
  const token = Cookies.get("token");
  let loading = true;
  let data = null;
  let errors = null;
  let headers = {};
  if (!file) headers["Content-Type"] = "application/json";

  await fetch(url, {
    ...options,
    headers: {
      Accept: blob ? "*/*" : "application/json;charset=UTF-8",
      ...headers,
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  })
    .then(async (r) => {
      if (blob) {
        return r.blob();
      }

      const contentType = r.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        return r.json();
      }

      const text = await r.text();
      return {
        status: r.status || 500,
        error: text || "Réponse serveur invalide",
      };
    })
    .then((data_) => {
      data = data_;
    })
    .catch((e) => {
      errors = e.toString();
    })
    .finally(() => {
      loading = false;
    });

  if (data?.status === 403 && data?.error === "Invalid token") {
    const opts = getSessionCookieRemoveOptions();
    removeUserDataCookie(opts);
    Cookies.remove("access", opts);
    Cookies.remove("token", opts);
    localStorage.clear();
    window.location.href = "/login";
  }

  return {
    loading,
    data,
    errors,
  };
}
